
// #region imports
import { Vue, Component } from 'vue-property-decorator'
// #endregion

// Vue instantiates the component
@Component
export default class DefaultLayout extends Vue {}
